import { render, staticRenderFns } from "./ModalMesasFaltantes.vue?vue&type=template&id=47d8cab3&scoped=true"
import script from "./ModalMesasFaltantes.vue?vue&type=script&lang=js"
export * from "./ModalMesasFaltantes.vue?vue&type=script&lang=js"
import style0 from "./ModalMesasFaltantes.vue?vue&type=style&index=0&id=47d8cab3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d8cab3",
  null
  
)

export default component.exports